<div
  class="relative overflow-x-auto rounded-[8px] w-full max-w-[1400px] mx-auto"
>
  <p-table
    #dt2
    [value]="bookings"
    [globalFilterFields]="['reference', 'status.status', 'customer.name', 'customer.cif', 'customer.email']"
    class="w-full text-sm text-left rtl:text-right text-gray-500"
  >
    <ng-template pTemplate="caption">
      <div class="flex">
          <input
            pInputText
            type="text"
            (input)="dt2.filterGlobal($any($event.target).value, 'contains')"
            placeholder="Buscar..."
          />

      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th scope="col" class="px-6 py-3">Acciones</th>
        <th scope="col" class="px-6 py-3">Referencia</th>
        <th scope="col" class="px-6 py-3">Pagado</th>
        <th scope="col" class="px-6 py-3">Total</th>
        <th scope="col" class="px-6 py-3">Tickets</th>
        <th scope="col" class="px-6 py-3">Participantes</th>
        <th scope="col" class="px-6 py-3">Items</th>
        <th scope="col" class="px-6 py-3" pSortableColumn="status.status">Estado <p-sortIcon field="status.status" /></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-booking>
      <tr>
        <td class="px-6 py-4">
          <button
            (click)="editBooking(booking)"
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Editar
          </button>
        </td>
        <td scope="row" class="px-6 py-4 whitespace-nowrap font-bold">
          <p>{{ booking.reference }}</p>
          <p>{{ booking.customer.name }}</p>
          <div [innerHTML]="returnAddressFromBooking(booking)"></div>
        </td>
        <td class="px-6 py-4">{{ booking.total_paid }}€</td>
        <td class="px-6 py-4">{{ booking.total_amount }}€</td>
        <td class="px-6 py-4">{{ returnTotalTickets(booking) }}</td>
        <td class="px-6 py-4">{{ booking?.participants?.length }}</td>
        <td
          class="px-6 py-4"
          [innerHTML]="returnItemsAndDrumsByBooking(booking)"
        ></td>
        <td class="px-6 py-4">
          <span
            class="inline-block text-nowrap py-1 px-5 rounded-[12px] font-bold {{
              getStatusColor(booking)
            }} {{ getStatusTextColor(booking) }}"
          >
            {{ getStatusName(booking) }}
          </span>
        </td>
      </tr>
      <tr class="border-b border-black-400">
        <th scope="row" class="px-6 py-4 whitespace-nowrap font-bold">Notas</th>
        <td class="px-6 py-4" colspan="7">
          <ng-container *ngIf="getNotesViewModel(booking) as vm">
            <div *ngIf="!vm.hasAnything" class="text-xs text-gray-500">
              Sin notas
            </div>

            <div *ngIf="vm.plainText" class="whitespace-pre-wrap break-words">
              {{ vm.plainText }}
            </div>

            <div *ngIf="vm.additionalData || vm.additionalRaw" class="mt-2">
              <div class="font-semibold text-xs text-gray-700 mb-1">
                Datos adicionales
              </div>

              <ng-container *ngIf="vm.additionalData; else rawAdditional">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-1 text-xs">
                  <div *ngFor="let kv of (vm.additionalData | keyvalue)">
                    <span class="font-semibold">{{ formatWebFormKey(kv.key) }}:</span>
                    <span class="ml-1">{{ formatWebFormValue(kv.value) }}</span>
                  </div>
                </div>
              </ng-container>

              <ng-template #rawAdditional>
                <pre class="whitespace-pre-wrap break-words font-mono text-xs bg-gray-100 p-2 rounded">{{ vm.additionalRaw }}</pre>
              </ng-template>
            </div>

            <div *ngIf="vm.serviceNotes.length > 0" class="mt-2">
              <div class="font-semibold text-xs text-gray-700 mb-1">
                Notas por servicio
              </div>
              <div class="text-xs">
                <div *ngFor="let sn of vm.serviceNotes" class="mb-1">
                  <span class="font-semibold">{{ sn.serviceName }}:</span>
                  <span class="ml-1 whitespace-pre-wrap break-words">{{ sn.note }}</span>
                </div>
              </div>
            </div>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
